var map = {
	"./decidim/simple_ui/decidim_simple_ui.svg": 4695,
	"./decidim/simple_ui/mpassid-nofill.svg": 5700,
	"./decidim/simple_ui/mpassid-white.svg": 3621,
	"./decidim/simple_ui/suomifi-nofill.svg": 7077,
	"./decidim/simple_ui/suomifi-white.svg": 1202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5586;